import { useEffect, useMemo } from 'react'

import { Icon, T } from 'govwell-ui'

import useDisclosure from 'src/hooks/use-disclosure'
import { useMyOrganizationMemberships } from 'src/hooks/use-my-organization-memberships'
import { useMyOrg } from 'src/layouts/AppStateContextLayout/utils'
import { formatCityState } from 'src/utils'

import OrgSwitcherPopover from './OrgSwitcherPopover'

const CityFooterDisplay = () => {
  const org = useMyOrg()
  const memberships = useMyOrganizationMemberships()
  const popoverState = useDisclosure()

  const city = org?.city ?? ''
  const state = org?.state
  const displayName = org?.displayName

  const hasMultipleOrgs = memberships.length > 1

  // Cmd/Ctrl + . to toggle the org switcher
  useEffect(() => {
    if (!hasMultipleOrgs) {
      return
    }
    const listener = (e: KeyboardEvent) => {
      if ((e.ctrlKey || e.metaKey) && e.key === '.') {
        e.preventDefault()
        popoverState.toggle()
      }
    }
    window.addEventListener('keydown', listener)
    return () => window.removeEventListener('keydown', listener)
  }, [hasMultipleOrgs, popoverState])

  const label = useMemo(
    () => displayName || formatCityState(city, state),
    [displayName, city, state]
  )

  if (!displayName && !city && !state) {
    return null
  }

  if (!hasMultipleOrgs) {
    return (
      <T.BodyLarge className="block px-2 py-1.5 !text-neutral-950 dark:!text-neutral-50">
        {label}
      </T.BodyLarge>
    )
  }

  return (
    <OrgSwitcherPopover
      isOpen={popoverState.isOpen}
      onOpen={popoverState.open}
      onClose={popoverState.close}
    >
      <button className="group flex w-full cursor-pointer items-center justify-between gap-1 rounded-md px-1.5 py-1.5 text-left transition-colors hover:bg-neutral-200 dark:hover:bg-neutral-600">
        <T.BodyLarge className="min-w-0 flex-1 !text-neutral-950 dark:!text-neutral-50">
          {label}
        </T.BodyLarge>
        <Icon.FaChevronDown className="h-3 w-3 flex-shrink-0 text-neutral-950 dark:text-neutral-50" />
      </button>
    </OrgSwitcherPopover>
  )
}

export default React.memo(CityFooterDisplay)
